import gsap from 'gsap';

export default ['.viewChangeAnimate', function () {
    'ngInject';

    return {
        enter: function (element, done) {
            gsap.TweenMax.set(element, { autoAlpha: 0 });
            gsap.TweenMax.to(element, 1, { autoAlpha: 1, onComplete: done });
            /*
            return function (isCancelled) {
                if (isCancelled) {
                    element.remove();
                }
            };
            */
        }
        /*
        ,
        leave: function (element, done) {
            gsap.TweenMax.set(element, { autoAlpha: 1 });
            gsap.TweenMax.to(element, 0.5, { autoAlpha: 0, onComplete: done });

            return function (isCancelled) {
                if (isCancelled) {
                    element.remove();
                }
            };
        }
        */
    };
}];



// WEBPACK FOOTER //
// ./src/app/animations/routerAnimation.js